var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckSquare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1765 0H2.82353C2.07468 0 1.35651 0.297478 0.826992 0.826992C0.297478 1.35651 0 2.07468 0 2.82353V13.1765C0 13.9253 0.297478 14.6435 0.826992 15.173C1.35651 15.7025 2.07468 16 2.82353 16H13.1765C13.9253 16 14.6435 15.7025 15.173 15.173C15.7025 14.6435 16 13.9253 16 13.1765V2.82353C16 2.07468 15.7025 1.35651 15.173 0.826992C14.6435 0.297478 13.9253 0 13.1765 0ZM14.1176 13.1765C14.1176 13.4261 14.0185 13.6655 13.842 13.842C13.6655 14.0185 13.4261 14.1176 13.1765 14.1176H2.82353C2.57391 14.1176 2.33452 14.0185 2.15802 13.842C1.98151 13.6655 1.88235 13.4261 1.88235 13.1765V2.82353C1.88235 2.57391 1.98151 2.33452 2.15802 2.15802C2.33452 1.98151 2.57391 1.88235 2.82353 1.88235H13.1765C13.4261 1.88235 13.6655 1.98151 13.842 2.15802C14.0185 2.33452 14.1176 2.57391 14.1176 2.82353V13.1765Z",
    fill: "#7E7E7E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5489 5.4922C11.287 5.22274 10.8542 5.22296 10.5924 5.49254C9.44341 6.67568 8.17606 7.97638 7.02725 9.15938L5.37378 7.71612C5.08973 7.46819 4.65717 7.50313 4.4166 7.79345V7.79345C4.18475 8.07324 4.21797 8.4868 4.49152 8.72599L6.63239 10.598V10.598C6.89301 10.8234 7.28476 10.807 7.52493 10.5599V10.5599C8.78053 9.2655 10.2478 7.76074 11.5494 6.42055C11.8005 6.16195 11.8002 5.75068 11.5489 5.4922V5.4922Z",
    fill: "#7E7E7E",
    stroke: "#7E7E7E",
    strokeWidth: 0.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckSquare);
export default __webpack_public_path__ + "static/media/CheckSquare.97a2affb.svg";
export { ForwardRef as ReactComponent };